module.exports = __webpack_public_path__ + "static/media/2XD.f94d09ed.gif";